/**
 * Created by m.igrachev on 7/20/2017.
 */
export default function getLocale(locale) {
    return locale || navigator.language || navigator.userLanguage;
}
